/* unplugin-vue-components disabled */import script from "./note-edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./note-edit.vue?vue&type=script&setup=true&lang=ts"

import "./note-edit.vue?vue&type=style&index=0&id=221ddf6d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221ddf6d"]])

export default __exports__